import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { defineComponent, computed } from "vue";
import { V as VaIcon } from "../va-icon/index-b0729838.mjs";
import { u as useLoadingProps } from "../../composables/useLoading-5a447e96.mjs";
import { u as useColors } from "../../composables/useColors-6d98be99.mjs";
const _sfc_main = defineComponent({
  name: "VaInnerLoading",
  components: { VaIcon },
  props: {
    ...useLoadingProps,
    ...useComponentPresetProp,
    color: { type: String },
    icon: { type: String, default: "autorenew" },
    size: { type: Number, default: 30 }
  },
  setup(props) {
    const { getColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    return {
      colorComputed,
      computedClass: computed(() => ({
        "va-inner-loading--active": props.loading
      })),
      ariaAttributesComputed: computed(() => ({
        "aria-busy": props.loading
      }))
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaInnerLoading.css';
//# sourceMappingURL=VaInnerLoading.vue_vue_type_script_lang-3f18a21f.mjs.map
